import request from '@/utils/request'

const prefix = '/django_rest/job-question'

export default {
  getQuestionTemplateGroupList (params) {
    return request.get(`${prefix}-template/group/`, { params })
  },
  createQuestionTemplateGroup (group) {
    return request.post(`${prefix}-template/group/`, group)
  },
  updateQuestionTemplateGroup (groupId, data) {
    return request.put(`${prefix}-template/group/${groupId}`, data)
  },
  createQuestionTemplate (question) {
    return request.post(`${prefix}-template/question/`, question)
  },
  updateQuestionTemplate (questionId, data) {
    return request.put(`${prefix}-template/question/${questionId}`, data)
  },
  moveGroupQuestionTemplate (fromGroup, toGroup, question, moveTo) {
    return request.post(`${prefix}-template/question/move/`, {
      from_group_id: fromGroup.id,
      to_group_id: toGroup.id,
      question_template_id: question.id,
      order: moveTo
    })
  },
  getDefaultQuestionTemplate (params) {
    return request.get(`${prefix}-template/question/default/`, { params })
  },
  getQuestionUpdateTaskList (params) {
    return request.get(`${prefix}/update/task/`, { params })
  }
}
